import { render, staticRenderFns } from "./paymentReports.vue?vue&type=template&id=71960cac&scoped=true&"
import script from "./paymentReports.vue?vue&type=script&lang=js&"
export * from "./paymentReports.vue?vue&type=script&lang=js&"
import style0 from "./paymentReports.vue?vue&type=style&index=0&id=71960cac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71960cac",
  null
  
)

export default component.exports